import { createFileRoute } from '@tanstack/react-router';
import DiscountMaintenancePage from '../../components/manager/DiscountMaintenancePage';
import ManagerPortal from '../../components/portals/ManagerPortal';

export const Route = createFileRoute('/manager/discounts')({
  component: DiscountManagementRoute,
});

function DiscountManagementRoute() {
  return (
    <ManagerPortal>
      <DiscountMaintenancePage />
    </ManagerPortal>
  );
}
